// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessPickaxe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m18.465 3.532 1.96 1.96c.47.47.598 1.145.397 1.73.931 2.027 1.08 4.29.922 6.094a1.214 1.214 0 0 1-.875 1.069c-.444.127-1.002 0-1.315-.498-.95-1.519-1.668-2.642-2.314-3.542a1.66 1.66 0 0 1-1.18-.488l-.25-.252L3.762 21.652a.5.5 0 0 1-.707 0l-.707-.707a.5.5 0 0 1 0-.707L14.395 8.19l-.295-.295a1.66 1.66 0 0 1-.488-1.161c-.909-.649-2.044-1.373-3.577-2.332a1.145 1.145 0 0 1-.505-1.276c.12-.45.509-.818 1.042-.87a13.631 13.631 0 0 1 4.244.284c.625.144 1.259.344 1.873.611a1.672 1.672 0 0 1 1.776.38zm-3.09.722a9.897 9.897 0 0 0-.898-.252 12.123 12.123 0 0 0-2.738-.3 64.18 64.18 0 0 1 2.529 1.66zm3.687 2.848-.001-.002.3-.3a.176.176 0 0 0 .005-.247l-1.962-1.96a.18.18 0 0 0-.253.007l-1.983 1.982a.193.193 0 0 0-.04.059.176.176 0 0 0 .036.188l1.96 1.961a.18.18 0 0 0 .254-.007l.316-.316.002.002zm-.456 2.577a61.885 61.885 0 0 1 1.691 2.57c.018-1.206-.133-2.498-.557-3.703z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessPickaxe;
